<template>
  <span>
    <NewQuotationGarantia v-if="userAreaIsGarantia" />
    <NewQuotationAgro v-if="userAreaIsAgro" />
  </span>
</template>
<script>
import { mapActions, mapState } from "vuex";
import NewQuotationGarantia from "./NewQuotationGarantia";
import NewQuotationAgro from "./NewQuotationAgro";

export default {
  components: {
    NewQuotationGarantia,
    NewQuotationAgro
  },
  computed: {
    ...mapState("me", ["userAreaIsGarantia", "userAreaIsAgro"])
  },
  created() {
    if (!this.userAreaIsGarantia && !this.userAreaIsAgro) {
      this.requestMyInfo();
    }
  },
  methods: {
    ...mapActions("me", ["requestMyInfo"])
  }
};
</script>
